/* ---------------------------------------------------------------------
 *                           Import Library
 * --------------------------------------------------------------------- */

// LocalCache
import { saveToStorage, getFromStorage, removeFromStorage } from "./localCache";

/* ---------------------------------------------------------------------
 *                            Set/Get LoginData
 * --------------------------------------------------------------------- */

/**
 * 存储登录数据到本地缓存
 * @param {Object} data - 登录数据对象
 * @returns {void} 
 */
export function setLoginData(loginData) {
    saveToStorage("loginData", loginData);
}

/**
 * 从本地缓存中获取登录数据
 * @return {Object} loginData
 */
export function getLoginData() {
    return getFromStorage("loginData");
}

/**
 * 获取访问令牌
 * @returns {string|null} accessToken
 */
export function getAccessToken() {
    const loginData = getLoginData();
    return loginData?.accessToken;
}

/**
 * 获取刷新令牌
 * @returns {string|null} refreshToken
 */
export function getRefreshToken() {
    const loginData = getLoginData();
    return loginData?.refreshToken;
}

/**
 * 获取客户端ID
 * @returns {string|null} clientId
 */
export function getClientId() {
    const loginData = getLoginData();
    return loginData?.clientId;
}

/* ---------------------------------------------------------------------
 *                             Helper Function
 * --------------------------------------------------------------------- */

/**
 * 检查token是否过期
 * @returns {boolean} 是否过期
 */
export function isTokenExpired() {
    const loginData = getLoginData();
    if (!loginData?.expireTime) return true;
    return Date.now() >= loginData.expireTime;
}

/**
 * 检查用户是否已登录
 * @returns {boolean} 是否已登录
 */
export function isLoggedIn() {
    const loginData = getLoginData();
    return loginData?.loggedIn;
}

/**
 * 删除登录数据
 * @returns {void} 
 */
export function removeLoginData() {
    removeFromStorage("loginData");
}